import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-wa-divider',
	templateUrl:'./WaDividerPluginCompPage.html',
	styles: [],
	styleUrls:['./WaDividerPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaDividerPluginCompPage
{
	mdContent_1130 = `\`\`\`java
import com.jwebmp.webawesome.components.divider.WaDivider;
\`\`\``;
	mdContent_1131 = `\`\`\`java
new WaDivider&lt;&gt;()
\`\`\``;
}
